import PropTypes from "prop-types";

import { ErrorMessage, Field } from "formik";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { DatePicker } from "@mui/x-date-pickers";


function DateFormField({ input, label, name,required=false }) {
  return (
    <MDBox mb={1.5}>
      <Field 
      {...input} 
      as={DatePicker} 
      label={required?<span style={{color:"red"}}>{label}</span>:label}
      />
      <MDBox mt={0.75}>
        <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
          <ErrorMessage name={name} />
        </MDTypography>
      </MDBox>
    </MDBox>
  );
}

DateFormField.propTypes = {
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  };
  
  export default DateFormField;